module.exports = __webpack_public_path__ + "img/login_title.9702ffaf.png";